import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { REG_HUB_COMMON_CONFIG, RegHubCommonConfig } from '../../reg-hub-common-config';
import { Observable } from 'rxjs';
import { ValidatedOrder } from '../../interfaces/validated-order';

@Injectable({
  providedIn: 'root'
})
export class OrderChangesService {
  constructor(
    private http: HttpClient,
    @Inject(REG_HUB_COMMON_CONFIG) private config: RegHubCommonConfig) { }
    
  public undoChange(orderID: string, changeID: string): Observable<ValidatedOrder> {
    return this.http.post<ValidatedOrder>(`${this.config.rootUrl}/orders/${orderID}/orderchanges/${changeID}/undo`, null);
  }
}
